import { AxiosInstance } from 'axios';
import router from '@/router';

export default (instance: AxiosInstance) => {
  instance.interceptors.response.use(({data}) => {
    if (data.redirect) {
      window.location = process.env.VUE_APP_API_GATEWAY + data.redirect;

      throw new Error('Not authorized');
    }

    return data;
  });
};
